// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes mCTUzLXnJL2JvCWaDuPl {
	0%,
	100% {
		opacity: 1;
	}
	50% {
		opacity: 0.5;
	}
}

._5Sr1bYLmbE0dzNsiLAI {
	display: flex;
	flex-direction: column;
	background: #f3f3f3;
	border-radius: 20px;
	padding: 16px;
	position: relative;
}

.__BAaMVh4FIsTv639VuA {
	font-weight: 400;
	font-size: 16px;
	line-height: 24px;
	display: flex;
	align-items: center;
	letter-spacing: -0.04em;
	margin-bottom: 15px;
}

.uq6RtygD6sJbglu2XUJg {
	align-items: center;
	display: flex;
	height: 36px;
	justify-content: space-between;
	margin-bottom: 16px;
}

.mfuuSkDA6fJb99X0mjtw {
	align-items: center;
	background: #fbfbfb;
	border-radius: 12px;
	color: #000000;
	display: flex;
	font-size: 16px;
	font-weight: 400;
	height: 36px;
	justify-content: center;
	letter-spacing: -0.08em;
	line-height: 20px;
	padding: 0 20px;
}

.aNbHo2yZDiGw2R5M3gxp {
	border: none;
	border-top: 1px solid rgba(0, 0, 0, 0.1);
	margin: 0 0 20px;
	width: 100%;
}

.soqLCEfz67ltfUrfj4vl {
	background: white;
	border-radius: 4px;
	height: 8px;
	overflow: hidden;
	width: 100%;
	margin-bottom: 12px;
}

.OCfb_8qJYD8u2SrpfIBo {
	animation: mCTUzLXnJL2JvCWaDuPl 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.cVkiuLZ1r525Q8Mlevnd {
	background: black;
	height: 100%;
	width: 100%;
	transform-origin: left;
	transition-property: transform, background;
	transition-duration: 0.25s;
	transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.jEFG4P3D_ojwcPByvlF4 {
	display: grid;
	grid-template-columns: repeat(5, 1fr);
	font-weight: 400;
	font-size: 16px;
	line-height: 24px;
	width: 100%;
	position: relative;
	height: 24px;
}

.jEFG4P3D_ojwcPByvlF4 div {
	position: absolute;
	left: calc(100% * var(--value));
	transform: translateX(-50%);
}

.jEFG4P3D_ojwcPByvlF4 div:first-child {
	transform: translateX(0);
}

.jEFG4P3D_ojwcPByvlF4 div:last-child {
	transform: translateX(-100%);
	text-align: right;
}
`, "",{"version":3,"sources":["webpack://./src/components/VeSIS/VeSIS.pcss"],"names":[],"mappings":"AAAA;CACC;;EAEC,UAAU;CACX;CACA;EACC,YAAY;CACb;AACD;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,mBAAmB;CACnB,aAAa;CACb,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;CACnB,aAAa;CACb,YAAY;CACZ,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;CACnB,mBAAmB;CACnB,mBAAmB;CACnB,cAAc;CACd,aAAa;CACb,eAAe;CACf,gBAAgB;CAChB,YAAY;CACZ,uBAAuB;CACvB,uBAAuB;CACvB,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,YAAY;CACZ,wCAAwC;CACxC,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,WAAW;CACX,gBAAgB;CAChB,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC,wEAAyD;AAC1D;;AAEA;CACC,iBAAiB;CACjB,YAAY;CACZ,WAAW;CACX,sBAAsB;CACtB,0CAA0C;CAC1C,0BAA0B;CAC1B,wDAAwD;AACzD;;AAEA;CACC,aAAa;CACb,qCAAqC;CACrC,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,WAAW;CACX,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,+BAA+B;CAC/B,2BAA2B;AAC5B;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,4BAA4B;CAC5B,iBAAiB;AAClB","sourcesContent":["@keyframes pulse {\n\t0%,\n\t100% {\n\t\topacity: 1;\n\t}\n\t50% {\n\t\topacity: 0.5;\n\t}\n}\n\n.container {\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground: #f3f3f3;\n\tborder-radius: 20px;\n\tpadding: 16px;\n\tposition: relative;\n}\n\n.title {\n\tfont-weight: 400;\n\tfont-size: 16px;\n\tline-height: 24px;\n\tdisplay: flex;\n\talign-items: center;\n\tletter-spacing: -0.04em;\n\tmargin-bottom: 15px;\n}\n\n.balanceRow {\n\talign-items: center;\n\tdisplay: flex;\n\theight: 36px;\n\tjustify-content: space-between;\n\tmargin-bottom: 16px;\n}\n\n.veSISLink {\n\talign-items: center;\n\tbackground: #fbfbfb;\n\tborder-radius: 12px;\n\tcolor: #000000;\n\tdisplay: flex;\n\tfont-size: 16px;\n\tfont-weight: 400;\n\theight: 36px;\n\tjustify-content: center;\n\tletter-spacing: -0.08em;\n\tline-height: 20px;\n\tpadding: 0 20px;\n}\n\n.separator {\n\tborder: none;\n\tborder-top: 1px solid rgba(0, 0, 0, 0.1);\n\tmargin: 0 0 20px;\n\twidth: 100%;\n}\n\n.progressBar {\n\tbackground: white;\n\tborder-radius: 4px;\n\theight: 8px;\n\toverflow: hidden;\n\twidth: 100%;\n\tmargin-bottom: 12px;\n}\n\n.loading {\n\tanimation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n}\n\n.progressBarProgress {\n\tbackground: black;\n\theight: 100%;\n\twidth: 100%;\n\ttransform-origin: left;\n\ttransition-property: transform, background;\n\ttransition-duration: 0.25s;\n\ttransition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.scale {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(5, 1fr);\n\tfont-weight: 400;\n\tfont-size: 16px;\n\tline-height: 24px;\n\twidth: 100%;\n\tposition: relative;\n\theight: 24px;\n}\n\n.scale div {\n\tposition: absolute;\n\tleft: calc(100% * var(--value));\n\ttransform: translateX(-50%);\n}\n\n.scale div:first-child {\n\ttransform: translateX(0);\n}\n\n.scale div:last-child {\n\ttransform: translateX(-100%);\n\ttext-align: right;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `_5Sr1bYLmbE0dzNsiLAI`,
	"title": `__BAaMVh4FIsTv639VuA`,
	"balanceRow": `uq6RtygD6sJbglu2XUJg`,
	"veSISLink": `mfuuSkDA6fJb99X0mjtw`,
	"veSisLink": `mfuuSkDA6fJb99X0mjtw`,
	"separator": `aNbHo2yZDiGw2R5M3gxp`,
	"progressBar": `soqLCEfz67ltfUrfj4vl`,
	"loading": `OCfb_8qJYD8u2SrpfIBo`,
	"pulse": `mCTUzLXnJL2JvCWaDuPl`,
	"progressBarProgress": `cVkiuLZ1r525Q8Mlevnd`,
	"scale": `jEFG4P3D_ojwcPByvlF4`
};
export default ___CSS_LOADER_EXPORT___;
